namespace Matrix.Dashboards {
    export interface ChartSeries {
        Field?: string;
        Title?: string;
        Type?: ChartType;
        BackgroundColor?: string;
        AreaFillColor?: string;
        ElementClickUrl?: string;
    }
}
